export default __webpack_public_path__ + "static/media/schedule_appointment_edit.e69e17fb.svg";